import styled from "styled-components";

export const GameContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
